import {Component, OnInit, ViewChild} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

import {AlertService} from '../../services/alert.service';


@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css'],
  animations: [
    trigger('hideAlertMsg', [
      state('true' , style({ opacity: 0 })),
      state('false', style({ opacity: 1 })),
      transition('0 => 1', animate('.5s')),
      transition('1 => 0', animate('.5s'))
    ])
  ]
})
export class AlertComponent implements OnInit {
  message = {'type': '', 'text': ''};

  x: number;
  y: number;
  width: number;
  height: number;

  hideAlertMsg: boolean = true;

  constructor(private alertService: AlertService) {
    this.x = 0;
    this.y = 0;
    this.width = 400;
    this.height = 50;
  }

  ngOnInit() {
    this.alertService.getMessage().subscribe(message => {
      this.message = (message === undefined) ? {'type': '', 'text': ''} : message;
      this.hideAlertMsg = false;
      setTimeout(function () {
        this.hideAlertMsg = true;
      }.bind(this), 5000);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/alert/alert.component.ts